import { CollectionInsightType } from '@components/collections/Model';
import { ViewType } from '@hooks/export/Model';
import { ElementType } from '@utils/page-analytics/model/AnalyticTrackingBasePropertiesObj';

export type LeaderboardTable = 'Leaderboard Table';
export type LeaderboardDoubleBarChart = 'Leaderboard Double Bar Chart';
export type TrendsLineChart = 'Trends Line Chart';
export type TrendsStackChart = 'Trends Stack Chart';
export type SegmentsStackedBarChart = 'Segments Stacked Chart';
export type ProductTrendsLineChart = 'Products Line Chart';
export type ExploreView =
  | LeaderboardTable
  | LeaderboardDoubleBarChart
  | TrendsLineChart
  | TrendsStackChart
  | SegmentsStackedBarChart
  | ProductTrendsLineChart;

export enum ExploreSegmentView {
  StackedChart = 'Stacked Chart',
}

export enum ExploreChartFiltersType {
  ShowPerformanceWithinFeature,
  SegmentByFeature,
}

export const ExploreViewTypeCollectionMapping: {
  'Segments Stacked Chart': CollectionInsightType;
  'Leaderboard Double Bar Chart': CollectionInsightType;
  'Trends Line Chart': CollectionInsightType;
  'Trends Stack Chart': CollectionInsightType;
  'Products Line Chart': CollectionInsightType;
} = {
  ['Leaderboard Double Bar Chart']: CollectionInsightType.ExploreBarChart,
  ['Trends Line Chart']: CollectionInsightType.ExploreLineChart,
  ['Segments Stacked Chart']: CollectionInsightType.ExploreSegmentsStackedBarChart,
  ['Trends Stack Chart']: CollectionInsightType.TrendStackBarChart,
  ['Products Line Chart']: CollectionInsightType.ProductTrendsMarketRetailerLineChart,
};

export const ExploreViewViewTypeMapping: Record<ExploreView, ViewType> = {
  ['Leaderboard Table']: ViewType.Table,
  ['Leaderboard Double Bar Chart']: ViewType.BarChart,
  ['Trends Line Chart']: ViewType.LineChart,
  ['Trends Stack Chart']: ViewType.StackedChart,
  ['Segments Stacked Chart']: ViewType.StackedChart,
};

export const ExploreViewElementTypeMapping: Record<ExploreView, ElementType> = {
  ['Leaderboard Table']: ElementType.TABLE,
  ['Leaderboard Double Bar Chart']: ElementType.BAR_CHART,
  ['Trends Line Chart']: ElementType.LINE_CHART,
  ['Trends Stack Chart']: ElementType.STACKED_CHART,
  ['Segments Stacked Chart']: ElementType.STACKED_CHART,
};
